import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import Hero from './components/Hero';
import Intro from './components/Intro';
import WindLoadCalculations from './components/WindLoadCalculations';
import BottomCTA from './components/BottomCTA';
import CertificationBanner from '@/components/feature/CertificationBanner';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://popprotents.com';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': `${siteUrl}/engineering-safety/#webpage`,
  name: 'Engineering & Safety — Wind Load Calculations & Certifications | Pop Pro Tents',
  description: 'Structural wind load calculations and industry certifications for Pop Pro Tents stretch tents, prepared by licensed structural engineers and accredited testing laboratories.',
  url: `${siteUrl}/engineering-safety`,
  isPartOf: {
    '@type': 'WebSite',
    '@id': `${siteUrl}/#website`,
    name: 'Pop Pro Tents',
    url: siteUrl,
  },
};

export default function EngineeringSafetyPage() {
  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <Intro />
        <CertificationBanner />
        <WindLoadCalculations />
        <BottomCTA />
      </main>
      <Footer />
    </div>
  );
}